/**
 * Client bunching for the funnel books. Sibling company-name variants
 * (Evidera (US) / (UK) / Inc. / Ltd) share a SharePoint client number
 * and group under one key; rows without a number (SharePoint emits
 * "NULL" for unassigned, normalised to null at sync) fall back to
 * their individual company name.
 */
export const clientKey = (i) =>
  i.client_number || `name:${i.client_company || "Unknown"}`;

const trimPrefix = (s) => s.replace(/[\s\-–(,._/]+$/g, "").trim();

export function buildClientIndex(items) {
  const byKey = new Map();
  for (const i of items) {
    const k = clientKey(i);
    const name = i.client_company || "Unknown";
    let names = byKey.get(k);
    if (!names) { names = new Map(); byKey.set(k, names); }
    names.set(name, (names.get(name) || 0) + 1);
  }
  const out = new Map();
  for (const [k, names] of byKey) {
    const variants = [...names.entries()]
      .sort((a, b) => b[1] - a[1])
      .map(([name, count]) => ({ name, count }));
    let label = variants[0].name;
    if (variants.length > 1) {
      let prefix = variants[0].name;
      for (const v of variants) {
        let j = 0;
        while (
          j < prefix.length && j < v.name.length &&
          prefix[j].toLowerCase() === v.name[j].toLowerCase()
        ) j++;
        prefix = prefix.slice(0, j);
      }
      // If the shared prefix stops mid-word in any variant (e.g.
      // "Evidera (U" from US)/UK)), retreat to the last separator.
      const sep = /[\s(\-–,./]/;
      const atBoundary = (name) =>
        prefix.length >= name.length || sep.test(name[prefix.length]);
      if (!variants.every((v) => atBoundary(v.name))) {
        let cut = -1;
        for (let j = prefix.length - 1; j >= 0; j--) {
          if (sep.test(prefix[j])) { cut = j; break; }
        }
        prefix = cut >= 0 ? prefix.slice(0, cut + 1) : "";
      }
      prefix = trimPrefix(prefix);
      if (prefix.length >= 3) label = prefix;
    }
    out.set(k, { label, variants });
  }
  return out;
}
